import App from "./App.vue";
import firebase from "firebase";
import router from "./router";
import store from "./store";
import Vue from "vue";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

// アプリのFirebase構成
const firebaseConfig = {
  apiKey: "AIzaSyBzSKtBHxEYJ8V0jLzR4u4tsyJC98uDShQ",
  authDomain: "yokkame-d5e81.firebaseapp.com",
  databaseURL: "https://yokkame-d5e81.firebaseio.com",
  projectId: "yokkame-d5e81",
  storageBucket: "yokkame-d5e81.appspot.com",
  messagingSenderId: "922778956720",
  appId: "1:922778956720:web:0e90aea492a1ca347a5c75",
  measurementId: "G-T200TEFG66",
};
// Firebaseを初期化
firebase.initializeApp(firebaseConfig);
// FirebaseのAnalyticsを使用
firebase.analytics();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
